<div class="w-full flex items-stretch flex-col" >
  <div class="flex justify-between">
    <div
      *ngFor="let eachLayout of contentData?.layout; let i = index; trackBy: trackByLayout"
      [ngStyle]="getWidth(eachLayout)"
      class="add-content-wrapper"
    >
      <div [id]="eachLayout?.uuid">
        <app-add-layout
          (layoutValueChangeEmitter)="onLayoutValueChange($event, i)"
          [layoutData]="contentData.layout[i]"
          class="w-full"></app-add-layout>
      </div>
      <div class="w-full content-section-wrapper">
        <div
          #leftResourceLayout
          *ngIf="i===0" leftResourceLayout></div>
        <div
          #middleResourceLayout
          *ngIf="i===1" middleResourceLayout></div>
        <div
          #rightResourceLayout
          *ngIf="i===2" rightResourceLayout></div>
      </div>
    </div>
  </div>

</div>
